<template lang="html">
  <div class="trello">
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="trello-lists" v-if="loaded">
      <div
        class="trello-list"
        v-for="(list, index) in lists"
        :key="index">

        <h2 class="list-heading">{{list.name}}</h2>

        <div class="list-cards" v-if="hasCards(list.id)">
          <ul>
            <li
              v-for="(card, index) in filteredCards(list.id)"
              :key="`card-${index}`">
              <p class="card-name">
                {{card.name}}
                <span class="label" v-if="hasLabel(card)">{{label(card)}}</span>
              </p>
              <p class="desc">{{card.desc}}</p>
            </li>
          </ul>
        </div>

        <div class="no-items" v-else>
          <p>No tasks in here.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ajax from '@/lib/ajax/ajax'
import notification from '@/mixins/notification'

export default {
  name: 'Trello',

  data() {
    return {
      loaded: false,
      lists: [],
      cards: []
    }
  },

  mixins: [notification],

  computed: {
    filteredCards() {
      return (listId) => {
        return this.cards.filter(card => card.idList === listId)
      }
    },

    boardId() {
      return this.$store.state.whiteLabel ? 'jAZ1ZneC' : 'h5zmnze6'
    },

    hasCards() {
      return (listId) => {
        return !!this.filteredCards(listId).length
      }
    },

    hasLabel() {
      return (card) => {
        return !!card.labels.length
      }
    },

    label() {
      return (card) => {
        return this.hasLabel(card) ? card.labels[0].name : false
      }
    }
  },

  methods: {
    getLists() {
      Ajax.request({
        url: `https://api.trello.com/1/boards/${this.boardId}/lists`,
        headers: {'Accept': 'application/json'},

        onSuccess: (xhr) => {
          this.lists = JSON.parse(xhr.responseText)
        },

        onError: (xhr) => {
          this.triggerNotification('error', 'trello lists', 'not found')
        }
      })
    },

    getCards() {
      Ajax.request({
        url: `https://api.trello.com/1/boards/${this.boardId}/cards`,
        headers: {'Accept': 'application/json'},

        onSuccess: (xhr) => {
          this.cards = JSON.parse(xhr.responseText)
          this.loaded = true
        },

        onError: (xhr) => {
          this.triggerNotification('error', 'trello cards', 'not found')
        }
      })
    }
  },

  mounted() {
    this.getLists()
    this.getCards()
  }
}
</script>

<style lang="sass">
  @import '../stylesheets/base/variables'
  @import '../stylesheets/base/theme'
  @import '../stylesheets/helpers/mixins'
  @import '../stylesheets/helpers/extends'

  .trello-lists
    display: flex
    flex-wrap: wrap
    flex-direction: column

    @include media($media-gt-x-large)
      flex-direction: row

    .trello-list
      @extend %card
      flex-basis: calc(#{percentage(1/3)} - #{$gap-small*2})
      margin: $gap-small 0
      padding: 0 $gap-small $gap-small 0

      &:nth-child(4)
        display: none

      @include media($media-gt-x-large)
        margin: 0 $gap-small
        max-height: 69vh
        overflow: auto
        -webkit-overflow-scrolling: touch

      ul
        list-style: none
        padding: 0

      li
        padding: $gap-small $gap-small
        border-bottom: 1px solid $color-border-light

        &:last-child
          border: none
          padding-bottom: 0

    .no-items
      text-align: center

      p
        font-size: 12px

    .list-cards
      p
        margin: 0

      .card-name
        font-weight: bold
        line-height: 1.6

      .label
        background: rgba(0, 0, 0, 0.1)
        padding: 2px 5px
        font-size: 9px
        border-radius: 3px
        position: relative
        top: -1px

      .desc
        font-size: 12px

    .list-heading
      margin: 0
      padding-top: $gap-small
      text-align: center
      font-size: 18px
      position: sticky
      top: 0
      background: rgba(255, 255, 255, 0.9)
</style>
